import axios from 'axios';

export class AiSettingsService
{
    private static getUrl()
    {
        const config = useRuntimeConfig();

        return config.public.localApiUrl;
    }

    private static getAuthHeader()
    {
        const { $auth } = useAuth();

        return { Authorization: `Bearer ${$auth.token()}` };
    }

    public static async getSettings()
    {
        return (await axios.get<AiSettings>('admin/ai/settings')).data;
    }

    public static async testSettings(params: {
        provider: string;
        owner: string;
        name: string;
        type: string;
    })
    {
        return (await axios.get<any>(`${this.getUrl()}/aicore/test-settings`, { params, headers: this.getAuthHeader() })).data;
    }
}

export default AiSettingsService;
